import type { SWRConfiguration } from 'swr';

/**
 * Configuration object for SWR (stale-while-revalidate) with specific settings.
 *
 * - `revalidateIfStale`: Disable revalidation if the data is stale.
 * - `revalidateOnFocus`: Disable revalidation when the window regains focus.
 * - `revalidateOnReconnect`: Disable revalidation when the network reconnects.
 *
 * @type {SWRConfiguration}
 */
export const config = {
  revalidateIfStale: true,
  revalidateOnMount: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
  dedupingInterval: 0,
  keepPreviousData: false,
} satisfies SWRConfiguration;
